import React, { useState } from "react";
import Header from "../../Components/header";
import Footer from "../../Components/footer";
import "../../assets/css/style.scss";
import aboutBanner from "../../assets/images/about-bg.jpg"


const Aboutus = () => {
    return (
        <>
            <div className="wrapper">
                <Header />
                <div className="image-box-container" style={{ backgroundImage: `url(${aboutBanner})` }}>
                    <div className="overlay-colored-Bg"></div>
                    <div className="container">
                        <div className="center-content">
                            <div className="banner-title">
                                <h1>Terms & Condition</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="pt-0 py-md-5 mt-md-5 mb-4 about-center-content">
                    <div className="container">
                        <div className="row panel-grid panel-no-style px-lg-5">

                            <div className="col-12 col-xl-12">
                                <div className="m-xl-5 px-3 px-md-0">

                                    <div className="notice_title">
                                        <h2 className="small-title--mt mb-3">~ Terms & Condition  ~</h2>
                                        <p>
                                            <b>
                                                Updated at 10-11-2023
                                            </b>
                                        </p>
                                    </div>

                                    <p class="mt-3">
                                        <div class="abt_offr">Acceptance of Terms: </div>
                                        By accessing or using this website, you agree to be bound by these terms and conditions.
                                        If you do not agree with any part of these terms, you may not access the website.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr"> Products and Pricing: </div>
                                        a. We reserve the right to modify or discontinue products without notice at any time. <br></br>
                                        b. Prices for products are subject to change without notice. <br></br>
                                        c. We do our best to display accurate product descriptions and images,
                                        but we do not warrant that the product descriptions or other content on
                                        the website are accurate, complete, reliable, current, or error-free.
                                    </p>


                                    <p class="mt-3">
                                        <div class="abt_offr">Orders and Payment: </div>

                                        a. By placing an order, you agree to pay the specified price. <br></br>
                                        b. We reserve the right to refuse or cancel an order for any reason, including errors in pricing or availability.<br></br>
                                        c. We use third party payment gateways for payments methods .
                                    </p>


                                    <p class="mt-3">
                                        <div class="abt_offr"> Shipping and Delivery: </div>

                                        a. Shipping costs can be provided during the checkout process and may vary based on location and shipping method. <br></br>
                                        b. We are not responsible for delays or damages during the shipping process, but we will assist in resolving any issues to the best of our ability.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr">Returns and Refunds: </div>

                                        a. We are not liable for any indirect, incidental, special, or consequential damages arising out of the use or inability to use the website or products.<br></br>
                                        b. Our total liability for any claim arising out of or relating to these terms or the website shall not exceed the amount paid by you for the product.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr"> Limitation of Liability: </div>
                                        We reserve the right to update this Privacy Policy at any time.
                                        Any changes will be posted on this page with an updated date.
                                    </p>

                                    <p class="mt-3">
                                        <div class="abt_offr">Changes to Terms and Conditions: </div>
                                        We reserve the right to modify these terms and conditions at any time. Changes will be effective immediately upon posting to the website.
                                    </p>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </>
    )
}
export default Aboutus;